'use client';

import { useBunja } from 'bunja/react';
import { useEffect } from 'react';

import { pswapTickersBunja } from '@flipster/r230522/original/pswap-ticker';

export interface SubscribePswapTickerProps {
  symbol: string;
}
const SubscribePswapTicker = ({ symbol }: SubscribePswapTickerProps) => {
  const { setCurrentTicker } = useBunja(pswapTickersBunja);
  useEffect(() => setCurrentTicker(symbol), [setCurrentTicker, symbol]);
  return null;
};

export default SubscribePswapTicker;
